// @ts-nocheck
import * as Types from '../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CostConfidencesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CostConfidencesQuery = { __typename?: 'Query', costConfidences: Array<{ __typename?: 'CostConfidenceDetail', name: string, code: Types.CostConfidence }> };


export const CostConfidencesDocument = gql`
    query CostConfidences {
  costConfidences {
    name
    code
  }
}
    `;

/**
 * __useCostConfidencesQuery__
 *
 * To run a query within a React component, call `useCostConfidencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostConfidencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostConfidencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCostConfidencesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CostConfidencesQuery, CostConfidencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CostConfidencesQuery, CostConfidencesQueryVariables>(CostConfidencesDocument, options);
      }
export function useCostConfidencesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CostConfidencesQuery, CostConfidencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CostConfidencesQuery, CostConfidencesQueryVariables>(CostConfidencesDocument, options);
        }
// @ts-ignore
export function useCostConfidencesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CostConfidencesQuery, CostConfidencesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CostConfidencesQuery, CostConfidencesQueryVariables>;
export function useCostConfidencesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CostConfidencesQuery, CostConfidencesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CostConfidencesQuery | undefined, CostConfidencesQueryVariables>;
export function useCostConfidencesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CostConfidencesQuery, CostConfidencesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CostConfidencesQuery, CostConfidencesQueryVariables>(CostConfidencesDocument, options);
        }
export type CostConfidencesQueryHookResult = ReturnType<typeof useCostConfidencesQuery>;
export type CostConfidencesLazyQueryHookResult = ReturnType<typeof useCostConfidencesLazyQuery>;
export type CostConfidencesSuspenseQueryHookResult = ReturnType<typeof useCostConfidencesSuspenseQuery>;
export type CostConfidencesQueryResult = ApolloReactCommon.QueryResult<CostConfidencesQuery, CostConfidencesQueryVariables>;